export default __webpack_public_path__ + "static/media/36I-102753_-15856_0.df865796.jpg";